import { UserRole } from "./user";

import type { DDLValues } from ".";

const FA = { title: "Facility Admin", id: UserRole.ADMIN };
const PC = { title: "Power Coder", id: UserRole.POWER };
const C = { title: "Coder", id: UserRole.CODER };
const CM = { title: "Case Manager", id: UserRole.MANAGER };
const NR = { title: "No Role", id: UserRole.NOROLE };

export const FacilityRoleCollection: DDLValues[] = [FA, PC, C, CM, NR];

// Mapping for API string conversion
export const UserRoleToApiString = {
  [UserRole.ADMIN]: "FacilityAdmin",
  [UserRole.POWER]: "PowerCoder",
  [UserRole.CODER]: "Coder",
  [UserRole.MANAGER]: "CaseManager",
  [UserRole.NOROLE]: "NoRole",
} as const;

// Reverse mapping for converting API strings back to UserRole enum
export const ApiStringToUserRole = {
  FacilityAdmin: UserRole.ADMIN,
  PowerCoder: UserRole.POWER,
  Coder: UserRole.CODER,
  CaseManager: UserRole.MANAGER,
  NoRole: UserRole.NOROLE,
} as const;

export const getUserRoleApiString = (role: UserRole): string =>
  UserRoleToApiString[role] || "NoRole";

export const getUserRoleFromApiString = (apiString: string): UserRole =>
  ApiStringToUserRole[apiString as keyof typeof ApiStringToUserRole] || UserRole.NOROLE;

export const getUserRoleDisplayName = (role: UserRole): string => {
  const roleItem = FacilityRoleCollection.find((item) => item.id === role);
  return roleItem?.title || "No Role";
};
